import { render, staticRenderFns } from "./Btbody.vue?vue&type=template&id=3a4617c0&scoped=true&"
import script from "./Btbody.vue?vue&type=script&lang=js&"
export * from "./Btbody.vue?vue&type=script&lang=js&"
import style0 from "./Btbody.vue?vue&type=style&index=0&id=3a4617c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4617c0",
  null
  
)

export default component.exports